<template>
  <main-layout>
    <div class="wrap">
      <div class="title">MANA {{this.$t('recruit.招聘')}}</div>
      <div class="typeBox clearfix">
        <span :class="type == 1? 'active':''" @click="changeType(1)">{{$t('recruit.职位')}}</span>
        <span :class="type == 2? 'active':''" @click="changeType(2)">{{$t('recruit.公司/机构')}}</span>
        <div class="searchBox">
          <div class="search">
            <input
              type="text"
              v-model="content"
              @keyup.enter="searchSubmit"
              :placeholder="$t('recruit.搜索职位/城市/公司')"
            />
            <img @click="searchSubmit" src="../../../static/home/head_search_icon@2x.png" alt />
          </div>
          <div class="submit" @click="submit">{{this.$t('recruit.发布新职位')}}</div>
        </div>
      </div>
      <div class="tagsBox">
        <div
          class="tags"
          :class="{ hideTags: openTages }"
          :style="openTages ? { height: rightScrollHeight + 'px' } : {}"
        >
          <div class="group clearfix">
            <div class="name">{{$t('recruit.工作地点')}}</div>
            <div class="clearfix" ref="industryTagHeight">
              <ul
                class="groupTag"
                ref="industryTagHeight1"
                :class="industryMore && industryTogger ? 'hideMore' : ''"
              >
                <li
                  class="groupTagLi"
                  :class="{ active: cityId == tag.id }"
                  v-for="(tag, y) in cityList"
                  :key="y"
                  @click="selectCity(tag,y)"
                >{{ language === "zh" ? tag.cityName : tag.cityEnName || tag.cityName }}</li>
              </ul>
            </div>
            <div v-if="industryMore" class="open">
              <span v-if="industryTogger" @click="classOpen(1)">
                {{$t('recruit.全部城市')}}
                <img
                  src="/static/newSearch/icon_more_arrow_grey_hover@2x.png"
                  alt
                />
              </span>
              <span v-else @click="classOpen(2)">
                {{ $t("global.收起")
                }}
                <img
                  src="/static/newSearch/icon_more_arrow_grey_close_hover@2x.png"
                  alt
                />
              </span>
            </div>
          </div>
          <div class="group clearfix" v-if="type==1">
            <div class="name">{{$t('recruit.职位类型')}}</div>
            <div class="clearfix" ref="classTagHeight">
              <ul class="groupTag clearfix">
                <li
                  class="groupTagLi"
                  :class="{ active: positionTypeId == tag.id || parentId == tag.id }"
                  v-for="(tag, y) in positionTypeList"
                  :key="y"
                  @click="selectType(tag,y)"
                >{{ language === "zh" ? tag.name : tag.enName || tag.name }}</li>
              </ul>
              <ul
                  class="subTag clearfix"
                  v-if="isShowChild"
                >
                  <li
                    class="subTagLi"
                    v-for="(tag, y) in childList"
                    :class="{ active: positionTypeId == tag.id }"
                    @click="selectType(tag,y)"
                    :key="y"
                  >
                    {{ language === "zh" ? tag.name : tag.enName || tag.name }}
                  </li>
                  <span></span>
                </ul>
            </div>
          </div>
          <div class="group clearfix" v-if="type==1">
            <div class="name">{{$t('recruit.职位性质')}}</div>
            <div class="clearfix" ref="classTagHeight1">
              <ul class="groupTag clearfix">
                <li
                  class="groupTagLi"
                  :class="{ active: item.id == recruitNature }"
                  v-for="(item, y) in recruitNatureList"
                  :key="y"
                  @click="selectNature(item)"
                >{{ item.name }}</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <swiper
        :options="swiperOption"
        ref="mySwiper"
        class="home-banner-swiper"
        v-if="locationList && locationList.length"
      >
        <!-- slides -->
        <swiper-slide v-for="(item, index) of locationList" :key="index">
          <div class="location" @mouseenter="on_top_enter" @mouseleave="on_top_leave">
            <img
              class="locationImg"
              @click="gotoLocation(item)"
              :src="JSON.parse(item.image)[0].key | imageUrl('', 2320, 732)"
              alt
            />
            <div class="advertisement" v-if="item.type == '2'">{{ $t("video.广告") }}</div>
          </div>
        </swiper-slide>
        <div
          class="swiper-pagination"
          slot="pagination"
          v-if="locationList.length && locationList.length > 1"
        ></div>
      </swiper>
      <div class="listBox" v-if="type==1">
        <div class="list clearfix" v-for="(item,i) in list" :key="i">
          <div
            class="leftBox"
            @click.stop.prevent="goto('recruitDetail', item.id)"
            @mouseenter="anliIndex=i"
            @mouseleave="anliIndex=null"
          >
            <div class="title1">
              <span>{{item.positionName}}</span>
              <!-- {{item.auditTime | dateToNow(language)}} -->
            </div>
            <div class="title2">
              <span>{{item.negotiable==1?$t('recruit.面议'):item.salaryBegin+'K-'+item.salaryEnd+"K"}}</span>
              / {{item.cityName}} / {{getExperience(item.experience)}} / {{getEducation(item.education)}} / {{getRecruitNature(item.recruitNature)}}
            </div>
            <div class="hoverBox" v-if="anliIndex == i" @click.stop.prevent>
              <div class="topBox">
                <div class="name1">{{item.positionName}}</div>
                <div class="name2">{{item.nickName}}</div>
              </div>
              <div class="infoBox">
                <div class="infoName">{{$t('recruit.职位描述')}}</div>
                <div class="text" v-html="getHtml(item.positionDes)"></div>
              </div>
            </div>
          </div>
          <div class="rightBox" @click.stop.prevent="goto('people', item.userId)">
            <span>{{item.nickName}}</span>
            <img :src="item.avatar | imageUrl('/static/profile_img_default.png',120,120)" alt />
          </div>
        </div>
      </div>
      <div class="listBox1" v-if="type==2">
        <div class="list1 clearfix" v-for="(item,i) in list" :key="i">
          <img
            :src="item.avatar | imageUrl('/static/profile_img_default.png',160,160)"
            @click.stop.prevent="goto('recruit', item.userId)"
            alt
          />
          <div class="info" @click.stop.prevent="goto('recruit', item.userId)">
            <p class="title1">{{item.nickName}}</p>
            <p class="address">
              <span v-for="(grop,y) in item.cityNames" :key="y">
                {{grop}}
                <i v-if="y+1 !== item.cityNames.length">/</i>
              </span>
            </p>
            <div class="tab">
              {{$t('recruit.正在招聘')}}
              <div class="nameBox">
                <span v-for="(grop,y) in item.positionNames" :key="y">
                  {{grop}}
                  <i v-if="y+1 !== item.positionNames.length">/</i>
                </span>
              </div>
              {{$t('recruit.等x个职位',{count: item.positionNames.length})}}
            </div>
          </div>
          <div
            class="seeInfo"
            @click.stop.prevent="goto('recruit1', item.userId)"
          >{{$t('recruit.查看公司介绍')}} ></div>
        </div>
      </div>
      <div class="noData" v-if="isShowData&&!list.length">
        <img src="https://image.manamana.net/1652689253000_undefinedfrQwDwR" alt />
        <p>{{$t('global.暂无数据')}}</p>
      </div>
      <pages
        :page-size="pageSize"
        :page-count="1"
        :current-page.sync="pageIndex"
        :total="totalRecord"
        @current-page-changed="changePage"
      ></pages>
    </div>
    <div class="popBox" v-if="isShowPop">
      <div class="box">
        <div class="title">
          {{popTitle}}
          <span @click="close"></span>
        </div>
        <div class="info">{{popInfo}}</div>
        <div class="but" v-if="popBut1 == ''">
          <span @click="but">{{popBut}}</span>
        </div>
        <div class="but1" v-else>
          <span @click="but" class="span1">{{popBut}}</span>
          <span @click="butnext" class="span2">{{popBut1}}</span>
        </div>
      </div>
    </div>
  </main-layout>
</template>

<script>
import MainLayout from "@/layouts/MainLayout";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import pages from "../../components/pages.vue";

export default {
  name: "ExploreSubject",
  metaInfo() {
    return {
      title: "MANA " + this.$t("global.招聘")
    };
  },
  components: {
    MainLayout,
    swiper,
    swiperSlide,
    pages
  },
  data() {
    return {
      type: 1,
      openTages: true,
      industryMore: false,
      rightScrollHeight: null,
      industryTogger: true,
      swiperOption: {
        autoplay: {
          delay: 5000,
          disableOnInteraction: false
        },
        speed: 1000,
        effect: "fade",
        pagination: {
          el: ".swiper-pagination", //分页器作用对象
          clickable: true //分页器小圆点是否可点击
        },
        on: {
          slideChangeTransitionEnd: () => {
            let swiper = this.$refs.mySwiper.swiper;
            let activeIndex = swiper.activeIndex;
            this.activeIndex = activeIndex;
          }
        }
      },
      locationList: [],
      isShowPop: false,
      popTitle: "",
      popInfo: "",
      popBut: "",
      popBut1: "",
      popType: 1,
      recruitNatureList: [
        { id: "", name: this.$t("recruit.不限") },
        { id: "1", name: this.$t("recruit.全职") },
        { id: "2", name: this.$t("recruit.实习生") },
        { id: "4", name: this.$t("recruit.兼职") }
      ],
      recruitNature: "",
      positionTypeId: 0,
      pageIndex: 1,
      pageSize: 15,
      totalRecord: 0,
      cityId: 0,
      cityList: [],
      positionTypeList: [],
      childList: [],
      list: [],
      content: "",
      isShowData: false,
      anliIndex: null,
      activeIndex: null,
      parentId: null,
      isShowChild: true
    };
  },
  created() {
    if (this.$route.query.type) {
      this.type = this.$route.query.type;
    }
    if (this.$route.query.cityId) {
      this.cityId = this.$route.query.cityId;
    }
    if (this.$route.query.positionTypeId) {
      this.positionTypeId = this.$route.query.positionTypeId;
    }
    if (this.$route.query.recruitNature) {
      this.recruitNature = this.$route.query.recruitNature;
    }
    if (this.$route.query.parentId) {
      this.parentId = this.$route.query.parentId;
    }
    this.buriedPoint(24, 0);
    this.getLocation();
    this.getList();
    this.getCity();
  },
  methods: {
    gotoLocation(item) {
      this.locationClick(item);
      this.openLocatione(item);
    },
    locationClick(item) {
      let params = {
        locationId: item.locationId,
        sort: item.sort,
        configId: item.id
      };
      this.$http.post("/api/operations/click", params).then(res => {
        //运营位点击
      });
    },
    getHtml(text) {
      let value = "";
      if (text) {
        value = text.replace(/(\r\n|\n|\r)/gm, "<br />");
      }
      return value;
    },
    searchSubmit() {
      if (!this.content.replace(/[\r\n\s]/g, "")) {
        // this.$message.error(this.$t("global.请输入搜索内容"));
        return;
      }
      this.$router.push({
        path: "/Search",
        query: { content: this.content, type: 6 }
      });
    },
    getExperience(i) {
      if (i == 1) {
        return this.$t("recruit.不限");
      }
      if (i == 2) {
        return this.$t("recruit.1年以下");
      }
      if (i == 3) {
        return this.$t("recruit.1-3年");
      }
      if (i == 4) {
        return this.$t("recruit.3-5年");
      }
      if (i == 5) {
        return this.$t("recruit.5-10年");
      }
      if (i == 6) {
        return this.$t("recruit.10年以上");
      }
    },
    getEducation(i) {
      if (i == 1) {
        return this.$t("recruit.不限");
      }
      if (i == 2) {
        return this.$t("recruit.大专");
      }
      if (i == 3) {
        return this.$t("recruit.本科");
      }
      if (i == 4) {
        return this.$t("recruit.硕士");
      }
      if (i == 5) {
        return this.$t("recruit.博士");
      }
    },
    getRecruitNature(i) {
      if (i == 1) {
        return this.$t("recruit.全职");
      }
      if (i == 2) {
        return this.$t("recruit.实习生");
      }
      if (i == 3) {
        return this.$t("recruit.校招");
      }
      if (i == 4) {
        return this.$t("recruit.兼职");
      }
    },
    selectCity(item, i) {
      this.cityId = item.id;
      this.getList();
      this.setRouteQuery();
    },
    selectType(item, i) {
      if (item.pid !== 0) {
        this.parentId = item.pid;
      } else {
        this.parentId = null;
      }
      // if (item.id === 0 || item.pid === 2669 || item.id === 2669 || item.child.length) {
      //   this.isShowChild = true;
      //   this.setHeight();
      // } else {
      //   this.isShowChild = false;
      //   this.setHeight();
      // }
      this.positionTypeId = item.id;
      this.getList();
      this.setRouteQuery();
    },
    selectNature(item) {
      this.recruitNature = item.id;
      this.getList();
      this.setRouteQuery();
    },
    changeType(type) {
      this.type = type;
      this.cityId = 0;
      this.pageIndex = 1;
      this.recruitNature = "";
      this.positionTypeId = 0;
      this.list = [];
      this.getList();
      this.setRouteQuery();
    },
    setRouteQuery() {
      this.$router.push({
        path: "/jobs/home",
        query: {
          type: this.type,
          cityId: this.cityId,
          positionTypeId: this.positionTypeId,
          recruitNature: this.recruitNature,
          parentId: this.parentId
        }
      });
    },
    getPositionType() {
      this.$http.get("/api/recruit/positionType/search/tree").then(res => {
        if (res.code == "OK") {
          if (res.data && res.data.length) {
            this.positionTypeList = res.data;
          }
          this.positionTypeList.unshift({
            id: 0,
            name: "不限",
            enName: "All"
          });
          this.childList = this.positionTypeList[1].child;
          this.childList.unshift({
            id: this.positionTypeList[1].id,
            name: "全部",
            enName: "All",
          });
          this.setHeight();
        }
      });
    },
    setHeight() {
      this.$nextTick(() => {
        if (this.$refs.industryTagHeight1.offsetHeight > 44) {
          this.industryMore = true;
        }
        setTimeout(() => {
          this.rightScrollHeight =
            this.$refs.classTagHeight.offsetHeight +
            this.$refs.industryTagHeight.offsetHeight +
            35;
        }, 50);
      });
    },
    getCity() {
      this.$http.get("/api/recruit/info/search/city").then(res => {
        if (res.code == "OK") {
          if (res.data && res.data.length) {
            this.cityList = res.data;
          }
          this.cityList.unshift({
            id: 0,
            cityName: "不限",
            cityEnName: "All"
          });
          this.getPositionType();
        }
      });
    },
    changePage(index) {
      this.goToTop();
      this.pageIndex = index;
      this.getList();
    },
    goToTop() {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    },
    getList() {
      let params = {
        cityId: this.cityId,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        positionTypeId: this.positionTypeId,
        recruitNature: this.recruitNature,
        type: this.type
      };
      this.$http
        .post("/api/recruit/info/search", params, {
          headers: {
            "Content-Type": "application/json"
          }
        })
        .then(res => {
          if (res.code == "OK") {
            this.list = res.data.list;
            this.totalRecord = res.data.totalRecord;
            this.isShowData = true;
          }
        });
    },
    close() {
      document.body.style.overflow = "";
      this.isShowPop = false;
    },
    but() {
      if (this.popType == 1) {
        this.close();
      }
      if (this.popType == 2) {
        this.close();
        this.$router.push("/MyRecruit?type=2");
      }
      if (this.popType == 3) {
        this.close();
        this.$router.push("/ApplyIdentification?type=1");
      }
      if (this.popType == 4) {
        this.close();
        this.$router.push("/payMeal/home");
      }
      if (this.popType == 5) {
        this.close();
        this.$router.push("/MyRecruit?type=3");
      }
    },
    butnext() {
      if (this.popType == 4) {
        this.close();
        this.$router.push("/releasePosition");
      }
      if (this.popType == 5) {
        this.close();
        this.$router.push("/payMeal/home");
      }
    },
    getLocation() {
      this.$http.get("/api/operations/list/21").then(res => {
        if (res.code === "OK") {
          this.locationList = res.data;
          this.locationShow(this.locationList[0]);
        }
      });
    },
    locationShow(item) {
      if (item.isFunc) {
        return;
      }
      let params = {
        locationId: item.locationId,
        sort: item.sort,
        configId: item.id
      };
      this.$http.post("/api/operations/show", params).then(res => {
        //运营位展示
        item.isFunc = true;
      });
    },
    on_top_enter() {
      this.$refs.mySwiper.swiper.autoplay.stop();
    },
    on_top_leave() {
      this.$refs.mySwiper.swiper.autoplay.start();
    },
    classOpen(index) {
      if (index == 1) {
        this.industryTogger = false;
      }
      if (index == 2) {
        this.industryTogger = true;
      }
      if (this.openTages) {
        if (this.type == 1) {
          this.$nextTick(() => {
            this.rightScrollHeight =
              this.$refs.classTagHeight.offsetHeight +
              this.$refs.industryTagHeight.offsetHeight +
              35;
          });
        }
        if (this.type == 2) {
          this.$nextTick(() => {
            this.rightScrollHeight = this.$refs.industryTagHeight.offsetHeight;
          });
        }
      }
    },
    goto(type, id, item) {
      let routeData = null,
        url = "";
      if (type == "people") {
        url = "/peopleCenter/" + id + "/home";
      }
      if (type == "recruitDetail") {
        url = "/recruitDetail/" + id;
      }
      if (type == "recruit") {
        url = "/peopleCenter/" + id + "/recruit";
      }
      if (type == "recruit1") {
        url = "/peopleCenter/" + id + "/recruit?recruitType=2";
      }
      routeData = this.$router.resolve({ path: url });
      window.open(routeData.href, "_blank");
    },
    submit() {
      this.$http.get("/api/u/recruit/company/status/pc").then(res => {
        if (res.code == "OK") {
          if (res.data.companyCertificationStatus == 1) {
            if (res.data.isClickBtn) {
              if (res.data.companyInfoStatus == 1) {
                if (res.data.isInRecruit) {
                  if (res.data.remainCount !== 0) {
                    this.$router.push("/releasePosition");
                  } else {
                    this.$http.get("/api/u/recruit/combo/current").then(res => {
                      if (res.data) {
                        this.popTitle = this.$t("recruit.发布职位");
                        this.popInfo = this.$t(
                          "recruit.您套餐内的职位数已用完，要发布更多职位请升级招聘套餐或购买职位数。"
                        );
                        this.popBut = this.$t("recruit.查看我的套餐");
                        this.popBut1 = this.$t("recruit.购买套餐");
                        this.popType = 5;
                        document.body.style.overflow = "hidden";
                        this.isShowPop = true;
                      } else {
                        this.popTitle = this.$t("recruit.发布职位");
                        this.popInfo = this.$t(
                          "recruit.您正在使用招聘套餐免费版，每年可免费发布5个职位。要发布更多职位请升级招聘套餐或购买职位数"
                        );
                        this.popBut = this.$t("recruit.了解套餐详情");
                        this.popBut1 = this.$t("recruit.继续发布");
                        this.popType = 4;
                        document.body.style.overflow = "hidden";
                        this.isShowPop = true;
                      }
                    });
                  }
                } else {
                  this.popTitle = this.$t("recruit.发布职位");
                  this.popInfo = this.$t(
                    "recruit.您正在使用招聘套餐免费版，每年可免费发布5个职位。要发布更多职位请升级招聘套餐或购买职位数"
                  );
                  this.popBut = this.$t("recruit.了解套餐详情");
                  this.popBut1 = this.$t("recruit.继续发布");
                  this.popType = 4;
                  document.body.style.overflow = "hidden";
                  this.isShowPop = true;
                }
              } else if (res.data.companyInfoStatus == 2) {
                this.popTitle = this.$t("recruit.完善公司信息");
                this.popInfo = this.$t(
                  "recruit.请先完善公司信息，完善后即可发布职位！"
                );
                this.popBut = this.$t("recruit.去完善");
                this.popType = 2;
                document.body.style.overflow = "hidden";
                this.isShowPop = true;
              }
            } else {
              this.popTitle = this.$t("recruit.完善公司信息");
              this.popInfo = this.$t(
                "recruit.请先完善公司信息，完善后即可发布职位！"
              );
              this.popBut = this.$t("recruit.去完善");
              this.popType = 2;
              document.body.style.overflow = "hidden";
              this.isShowPop = true;
            }
          }
          if (res.data.companyCertificationStatus == 2) {
            this.popTitle = this.$t("recruit.企业认证");
            this.popInfo = this.$t(
              "recruit.您的企业认证信息正在审核中，审核通过后即可发布职位信息，请耐心等待"
            );
            this.popBut = this.$t("recruit.确定");
            this.popType = 1;
            document.body.style.overflow = "hidden";
            this.isShowPop = true;
          }
          if (res.data.companyCertificationStatus == 3) {
            this.popTitle = this.$t("recruit.企业认证");
            this.popInfo = this.$t(
              "recruit.请先进行企业认证，认证通过后即可发布招聘信息"
            );
            this.popBut = this.$t("recruit.去认证");
            this.popType = 3;
            document.body.style.overflow = "hidden";
            this.isShowPop = true;
          }
          if (res.data.companyCertificationStatus == 4) {
            this.popTitle = this.$t("recruit.企业认证");
            this.popInfo = this.$t(
              "recruit.您的企业认证信息未通过，请联系客服"
            );
            this.popBut = this.$t("recruit.确定");
            this.popType = 1;
            document.body.style.overflow = "hidden";
            this.isShowPop = true;
          }
        }
      });
    }
  },
  watch: {
    type(val) {
      if (val == 1) {
        this.$nextTick(() => {
          if (this.$refs.industryTagHeight1.offsetHeight > 44) {
            this.industryMore = true;
          }
          setTimeout(() => {
            this.rightScrollHeight =
              this.$refs.classTagHeight.offsetHeight +
              this.$refs.industryTagHeight.offsetHeight +
              35;
          }, 50);
        });
      }
      if (val == 2) {
        this.$nextTick(() => {
          if (this.$refs.industryTagHeight1.offsetHeight > 44) {
            this.industryMore = true;
          }
          setTimeout(() => {
            this.rightScrollHeight = this.$refs.industryTagHeight.offsetHeight;
          }, 50);
        });
      }
    },
    activeIndex(val) {
      this.locationShow(this.locationList[val]);
    }
  },
  computed: {
    language() {
      return this.$language();
    }
  }
};
</script>
<style>
.swiper-pagination {
  bottom: 12px !important;
}
.swiper-pagination-bullet {
  width: 6px;
  height: 6px;
  opacity: 1;
  background: rgba(255, 255, 255, 0.3);
  border-radius: 100%;
}
.swiper-pagination-bullet-active {
  background: #ffffff;
}
</style>
<style lang="stylus" scoped>
.wrap {
  width: 1110px;
  margin: 0 auto;
  padding: 60px 0;

  .title {
    height: 42px;
    font-size: 30px;
    font-weight: 600;
    color: #333333;
    line-height: 42px;
    margin-bottom: 20px;
  }

  .typeBox {
    height: 36px;

    span {
      height: 30px;
      font-size: 16px;
      font-weight: 400;
      color: #999999;
      line-height: 30px;
      display: inline-block;
      margin-right: 30px;
      box-sizing: border-box;
      cursor: pointer;
    }

    span.active {
      font-weight: 600;
      color: #333333;
      border-bottom: 1px solid #333;
    }

    .searchBox {
      float: right;

      .search {
        position: relative;
        display: inline-block;

        input {
          width: 203px;
          height: 36px;
          border: 2px solid #EBEBEB;
          box-sizing: border-box;
          padding: 0 40px 0 12px;
        }

        img {
          width: 18px;
          height: 18px;
          position: absolute;
          right: 11px;
          top: 9px;
          cursor: pointer;
        }
      }

      .submit {
        display: inline-block;
        width: 104px;
        height: 36px;
        line-height: 36px;
        text-align: center;
        background: #2026CC;
        font-size: 14px;
        font-weight: 600;
        color: #FFFFFF;
        cursor: pointer;
      }
    }
  }

  .tagsBox {
    position: relative;

    .tags {
      background: rgba(245, 245, 245, 1);
      margin: 20px auto;
      width: 1070px;
      padding: 10px 20px;
      font-size: 13px;

      .group {
        border-bottom: 1px solid #E0E0E0;
        position: relative;

        &:nth-child(4) {
          border-bottom: none;
        }

        .name {
          width: 70px;
          float: left;
          padding-top: 15px;
          color: #999;
          font-weight: 500;
        }

        .open {
          position: absolute;
          right: 0;
          top: 12px;
          cursor: pointer;

          span {
            font-size: 13px;
            font-weight: 400;
            color: rgba(153, 153, 153, 1);

            img {
              width: 20px;
              height: 20px;
              vertical-align: bottom;
            }

            &:hover {
              color: #333;
            }
          }
        }

        .groupTag {
          width: 945px;
          float: left;
          padding-bottom: 10px;

          .groupTagLi {
            float: left;
            margin-right: 36px;
            color: #333;
            font-weight: 400;
            height: 24px;
            line-height: 24px;
            margin-top: 10px;
            cursor: pointer;
            font-size: 13px;

            &:hover {
              color: #2026CC;
            }
          }

          .active {
            background: rgba(32, 38, 204, 1);
            font-weight: 600;
            color: rgba(255, 255, 255, 1);
            padding: 0 10px;
            margin-right: 24px;

            &:hover {
              color: rgba(255, 255, 255, 1);
            }
          }
        }

        .subTag {
          width: 952px;
          padding: 2px 24px 12px;
          float: left;
          margin-left: 70px;
          background: rgba(255, 255, 255, 1);
          margin-bottom: 10px;
          position: relative;
          .subTagLi {
            float: left;
            margin-right: 36px;
            color: rgba(102, 102, 102, 1);
            font-weight: 400;
            height: 20px;
            line-height: 20px;
            margin-top: 10px;
            cursor: pointer;
            &:hover {
              color: #2026CC;
            }
          }
          span{
            position: absolute;
            border: 5px solid transparent;
            border-bottom: 5px solid #fff;
            top: -10px;
            left: 75px;
          }
          .active {
            color: #2026CC;
            font-weight: 600;
          }
        }

        .hideMore {
          height: 36px;
          overflow: hidden;
        }
      }

      .hideBottom {
        border-bottom: none;
      }
    }

    .hideTags {
      overflow: hidden;
    }

    .openTages {
      position: absolute;
      width: 44px;
      height: 20px;
      background: rgba(245, 245, 245, 1);
      left: 50%;
      transform: translateX(-50%);
      bottom: -20px;
      text-align: center;
      cursor: pointer;

      img {
        width: 20px;
        height: 20px;
      }
    }
  }

  .location {
    width: 1110px;
    height: 100px;
    position: relative;
    cursor: pointer;

    .locationImg {
      width: 100%;
      height: 100%;
      display: inline-block;
    }

    .advertisement {
      position: absolute;
      left: 0;
      bottom: 0;
      padding: 0 4px;
      height: 16px;
      background: rgba(51, 51, 51, 0.4);
      border-radius: 0px 6px 0px 0px;
      line-height: 16px;
      text-align: center;
      font-size: 10px;
      font-weight: 400;
      color: rgba(255, 255, 255, 0.8);
    }
  }

  .listBox {
    .list {
      height: 120px;
      border-bottom: 1px solid #EBEBEB;
      box-sizing: border-box;
      cursor: pointer;

      .leftBox {
        float: left;
        width: 610px;
        position: relative;
        height: 100%;
        .title1 {
          height: 28px;
          line-height: 28px;
          font-size: 12px;
          font-weight: 400;
          color: #999999;
          margin: 30px 0 7px 0;

          span {
            display: inline-block;
            max-width: 90%;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            margin-right: 10px;
            font-size: 20px;
            font-weight: 600;
            color: #333333;
            vertical-align: bottom;
          }
        }

        .title2 {
          height: 25px;
          font-size: 14px;
          font-weight: 400;
          color: #333;
          line-height: 25px;

          span {
            color: #FC703E;
            font-size: 18px;
            font-weight: 600;
          }
        }

        .hoverBox {
          position: absolute;
          left: 343px;
          width: 424px;
          background: #FFFFFF;
          box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.1);
          border: 1px solid #E5E5E5;
          top: 20px;
          padding-bottom: 20px;
          z-index: 111;

          .topBox {
            height: 62px;
            background: #F5F4F4;
            padding: 10px 20px 0;

            .name1 {
              height: 24px;
              font-size: 16px;
              font-weight: 600;
              color: #333333;
              line-height: 24px;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              margin-bottom: 10px;
            }

            .name2 {
              height: 18px;
              font-size: 12px;
              font-weight: 400;
              color: #999999;
              line-height: 18px;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
          }

          .infoBox {
            padding: 0 20px;

            .infoName {
              font-size: 12px;
              font-weight: 400;
              color: #333333;
              line-height: 24px;
            }

            .text {
              font-size: 12px;
              font-weight: 400;
              color: #333333;
              line-height: 24px;
              height: 130px;
              overflow-y: auto;
            }
          }
        }
      }

      .rightBox {
        float: right;
        margin-top: 30px;

        span {
          display: inline-block;
          width: 420px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          font-size: 18px;
          font-weight: 600;
          color: #333333;
          height: 25px;
          line-height: 25px;
          vertical-align: middle;
        }

        img {
          width: 60px;
          height: 60px;
          border-radius: 50%;
        }
      }
    }
  }

  .listBox1 {
    .list1 {
      height: 138px;
      line-height: 138px;
      border-bottom: 1px solid #EBEBEB;
      cursor: pointer;

      img {
        float: left;
        width: 80px;
        height: 80px;
        border-radius: 50%;
        margin-right: 15px;
        margin-top: 30px;
      }

      .info {
        float: left;
        margin-top: 32px;

        .title1 {
          height: 28px;
          font-size: 20px;
          font-weight: 600;
          color: #333333;
          line-height: 28px;
        }

        .address {
          height: 18px;
          font-size: 12px;
          font-weight: 400;
          color: #999999;
          line-height: 18px;
          margin: 5px 0;
          max-width: 800px;
          overflow: hidden;
          text-overflow: ellipsis;
          vertical-align: middle;
          white-space: nowrap;
        }

        .tab {
          height: 20px;
          font-size: 14px;
          font-weight: 400;
          color: #333333;
          line-height: 20px;

          .nameBox {
            display: inline-block;
            max-width: 700px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            vertical-align: bottom;
          }
        }
      }

      .seeInfo {
        float: right;
        width: 125px;
        height: 30px;
        border: 1px solid #2026CC;
        box-sizing: border-box;
        line-height: 30px;
        text-align: center;
        margin-top: 55px;
        font-size: 14px;
        font-weight: 600;
        color: #2026CC;
        cursor: pointer;
      }
    }
  }

  .noData {
    text-align: center;

    img {
      width: 284px;
      height: 276px;
      margin: 160px 0 40px 0;
    }

    p {
      height: 22px;
      font-size: 16px;
      font-weight: 400;
      color: #354052;
      line-height: 22px;
    }
  }
}

.popBox {
  position: fixed;
  width: 100%;
  height: 100vh;
  left: 0;
  top: 0;
  background: rgba(0, 0, 0, 0.4);
  z-index: 111;

  .box {
    width: 540px;
    padding-bottom: 50px;
    background: #fff;
    position: absolute;
    left: 50%;
    top: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);

    .title {
      text-align: center;
      height: 60px;
      line-height: 60px;
      border-bottom: 1px solid #e0e0e0;
      font-size: 18px;
      font-weight: 600;
      color: #333;
      position: relative;

      span {
        position: absolute;
        color: #999;
        right: 24px;
        top: 25px;
        width: 13px;
        height: 13px;
        cursor: pointer;
        background: url('/static/uploadvideo/close_btn@2x.png') no-repeat;
        background-size: 100% 100%;
      }
    }

    .info {
      font-size: 16px;
      font-weight: 400;
      color: #333333;
      line-height: 24px;
      margin: 44px 0 54px 0;
      padding: 0 102px;
      text-align: center;
    }

    .info1 {
      margin-bottom: 10px;
    }

    .but {
      text-align: center;

      span {
        padding: 0 35px;
        height: 40px;
        background: #2026CC;
        font-size: 16px;
        font-weight: 600;
        color: #FFFFFF;
        text-align: center;
        line-height: 40px;
        cursor: pointer;
        display: inline-block;
      }
    }

    .but1 {
      text-align: center;

      span {
        padding: 0 35px;
        height: 40px;
        font-size: 16px;
        font-weight: 600;
        text-align: center;
        line-height: 40px;
        cursor: pointer;
        display: inline-block;
        margin-right: 15px;
      }

      span.span1 {
        border: 1px solid #2026CC;
        color: #2026CC;
      }

      span.span2 {
        background: #2026CC;
        color: #FFFFFF;
      }
    }
  }

  .box1 {
    padding-bottom: 23px;
  }

  .box2 {
    width: 760px;
    padding-bottom: 30px;
    background: #fff;
    position: absolute;
    left: 50%;
    top: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    overflow: hidden;

    .title {
      padding-left: 30px;
      height: 60px;
      line-height: 60px;
      border-bottom: 1px solid #e0e0e0;
      font-size: 18px;
      font-weight: 600;
      color: #333;
      position: relative;

      i {
        font-size: 12px;
        font-weight: 400;
        color: #999999;
        margin-left: 10px;
      }

      span {
        position: absolute;
        color: #999;
        right: 24px;
        top: 25px;
        width: 13px;
        height: 13px;
        cursor: pointer;
        background: url('/static/uploadvideo/close_btn@2x.png') no-repeat;
        background-size: 100% 100%;
      }
    }

    .typeBox1 {
      margin: 18px 0 26px 0;
      text-align: center;

      span {
        height: 20px;
        font-size: 14px;
        font-weight: 400;
        color: #333333;
        line-height: 20px;
        display: inline-block;
        margin-right: 30px;
        cursor: pointer;
      }

      span.active {
        font-weight: 600;
        color: #2026CC;
        border-bottom: 1px solid #2026CC;
      }
    }

    .videoBox {
      padding: 0 15px;
      max-height: 436px;
      overflow-y: scroll;
      margin-bottom: 30px;
      margin-right: -17px;

      .video {
        width: 230px;
        float: left;
        margin-right: 20px;

        &:nth-child(3n) {
          margin-right: 0;
        }

        .imgBox {
          width: 230px;
          position: relative;

          .img1 {
            width: 230px;
            height: 129px;
          }

          .img2 {
            width: 17px;
            height: 18px;
            position: absolute;
            border-radius: 50%;
            top: 8px;
            right: 8px;
            cursor: pointer;
          }

          span {
            position: absolute;
            font-size: 12px;
            font-weight: 400;
            color: #FFFFFF;
            left: 8px;
            top: 8px;
          }

          i {
            position: absolute;
            width: 17px;
            height: 17px;
            border: 1px solid #FFFFFF;
            border-radius: 50%;
            top: 8px;
            right: 8px;
            color: #fff;
            cursor: pointer;
          }
        }

        .videoTitle {
          margin-top: 5px;
          height: 34px;
          font-size: 12px;
          font-weight: 400;
          color: #333333;
          line-height: 17px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          word-break: break-word;
        }
      }
    }

    .photoBox {
      margin-bottom: 60px;

      .photTitle {
        height: 17px;
        font-size: 12px;
        font-weight: 400;
        color: #FF0000;
        line-height: 17px;
        padding-left: 24px;
        margin-bottom: 10px;
      }

      .photoBox1 {
        padding: 0 15px;

        .photo {
          float: left;
          margin-right: 20px;

          &:nth-child(3n) {
            margin-right: 0;
          }

          .imgBox {
            position: relative;
            width: 230px;
            height: 129px;
            margin-bottom: 10px;

            img {
              position: absolute;
              left: 0;
              right: 0;
              top: 0;
              bottom: 0;
              z-index: 1;
              width: 100%;
              height: 100%;
            }

            span {
              position: absolute;
              font-size: 12px;
              font-weight: 400;
              color: #FFFFFF;
              top: 6px;
              right: 7px;
              z-index: 3;
              cursor: pointer;
            }

            .backG {
              width: 100%;
              height: 100%;
              position: absolute;
              left: 0;
              right: 0;
              top: 0;
              bottom: 0;
              z-index: 2;
              background: rgba(0, 0, 0, 0.5);
            }
          }

          .photTitle1 {
            width: 230px;
            height: 52px;
          }
        }

        .upImg {
          float: left;
          width: 230px;
          height: 191px;
          border: 1px solid #979797;
          box-sizing: border-box;
          text-align: center;
          line-height: 190px;
          cursor: pointer;

          &:nth-child(3n) {
            margin-right: 0;
          }
        }
      }
    }

    .but {
      text-align: center;

      span {
        padding: 0 35px;
        height: 40px;
        background: #2026CC;
        font-size: 16px;
        font-weight: 600;
        color: #FFFFFF;
        text-align: center;
        line-height: 40px;
        cursor: pointer;
        display: inline-block;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/jobs/home.vue